import React, { useState, useEffect } from 'react';
import { AlertCircle, Download, Search } from 'lucide-react';
import axios from 'axios';

const DueFees = () => {
  const [dueFees, setDueFees] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);

  const API_URL = process.env.REACT_APP_BACKEND_URL;
  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchDueFees();
  }, []);

  const fetchDueFees = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/api/fees/due-fees`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setDueFees(response.data);
    } catch (error) {
      console.error('Error fetching due fees:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredDueFees = dueFees.filter(item =>
    item.student_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.admission_number.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalDue = dueFees.reduce((sum, item) => sum + item.due_amount, 0);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Due Fees</h1>
          <p className="text-sm text-gray-500 mt-1">Students with pending fee payments</p>
        </div>
        <button className="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700">
          <Download className="h-4 w-4" />
          Export List
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Total Due Amount</p>
              <p className="text-3xl font-bold text-red-600 mt-1">₹{totalDue.toLocaleString('en-IN')}</p>
            </div>
            <AlertCircle className="h-12 w-12 text-red-500" />
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Students with Dues</p>
              <p className="text-3xl font-bold text-gray-900 mt-1">{dueFees.length}</p>
            </div>
            <AlertCircle className="h-12 w-12 text-orange-500" />
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Average Due</p>
              <p className="text-3xl font-bold text-gray-900 mt-1">₹{dueFees.length > 0 ? Math.round(totalDue / dueFees.length) : 0}</p>
            </div>
            <AlertCircle className="h-12 w-12 text-yellow-500" />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-4">
        <div className="relative">
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
          <input
            type="text"
            placeholder="Search by student name or admission number..."
            className="pl-10 pr-4 py-2 w-full border rounded-lg"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Student Name</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Admission No.</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Due Amount</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Action</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {loading ? (
              <tr><td colSpan="4" className="px-6 py-8 text-center text-gray-500">Loading...</td></tr>
            ) : filteredDueFees.length === 0 ? (
              <tr><td colSpan="4" className="px-6 py-8 text-center text-gray-500">No due fees found</td></tr>
            ) : (
              filteredDueFees.map((item) => (
                <tr key={item.student_id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm font-medium text-gray-900">{item.student_name}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">{item.admission_number}</td>
                  <td className="px-6 py-4 text-sm text-right font-medium text-red-600">₹{item.due_amount}</td>
                  <td className="px-6 py-4 text-right">
                    <button className="text-blue-600 hover:text-blue-900 text-sm font-medium">Send Reminder</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DueFees;